import { Action, action, thunk, Thunk } from 'easy-peasy';
import { Crumb } from '@types';

export interface AppModel {
  loader: boolean;
  crumbs?: Crumb[];
  formStage?: string;
  userName?: string;
  userEmail?: string;
  userPhone?: string;
  setLoader: Action<AppModel, boolean>;
  setCrumbs: Action<AppModel, Crumb[]>;
  setFormStage: Action<AppModel, string>;
  setUserName: Action<AppModel, string>;
  setUserEmail: Action<AppModel, string>;
  setUserPhone: Action<AppModel, string>;
  showLoader: Thunk<AppModel>;
  closeLoader: Thunk<AppModel>;  
}

const appModel: AppModel = {
  loader: false,
  setLoader: action((state, payload) => {
    state.loader = payload;
  }),
  setCrumbs: action((state, payload) => {
    state.crumbs = payload;
  }),
  setFormStage: action((state, payload) => {
    state.formStage = payload;
  }),
  setUserName: action((state, payload) => {
    state.userName = payload;
  }),
  setUserEmail: action((state, payload) => {
    state.userEmail = payload;
  }),
  setUserPhone: action((state, payload) => {
    state.userPhone = payload;
  }),
  showLoader: thunk((actions) => {
    actions.setLoader(true);
  }),
  closeLoader: thunk((actions) => {
    actions.setLoader(false);
  }),  
};

export default appModel;
